import { useEffect } from 'react'
import { FormApi } from 'final-form'
import { Typography, Spacer, Button } from '@jisr-hr/ds'
import i18n from 'translations/i18n'
import { useDispatch } from 'utils/hooks'
import { Form } from 'components/final-form'
import { email } from 'components/global/form/FormValidations'
import { listOnboardingAdmins } from 'redux/organizationOnborading/inviteAdmins/actionCreators'
import NewTextInputField from 'containers/authorised/ATS/organisms/CreateCandidateDrawer/InputTextField/InputTextField'

type TProps = {
  fetching: boolean
  onSubmit: (
    values: { email: string },
    fun: FormApi<{ email: string }, Partial<{ email: string }>>,
  ) => void
}

const InviteForm = (props: TProps): JSX.Element => {
  const { fetching } = props
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(listOnboardingAdmins())
  }, [])

  return (
    <>
      <Typography
        variant="heading"
        text={i18n.t('label.invite_admins')}
      />
      <Typography
        variant="subtitle-1"
        style={{ color: 'var(--ds-base-color-content-on-neutral-fg)', maxWidth: 500 }}
        text={i18n.t(
          'description.admins_can_help_you_with_setting_up_your_workspace._you_can_change_admins_permissions_later',
        )}
      />
      <Spacer height={32} />
      <Form onSubmit={props.onSubmit}>
        {({ handleSubmit, pristine }): JSX.Element => (
          <form
            onSubmit={handleSubmit}
            style={{ maxWidth: 393 }}
          >
            <NewTextInputField
              size="lg"
              name="email"
              style={{ width: 235 }}
              placeholder={i18n.t('label.enter_email_address')}
              validate={email}
              actionButton={
                <Button
                  size="sm"
                  disabled={fetching || pristine}
                  style={{ width: 172 }}
                  onClick={handleSubmit}
                  label={i18n.t('label.send_invitation')}
                />
              }
            />
          </form>
        )}
      </Form>
    </>
  )
}

export default InviteForm
